var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"md":"10"}},[_c('h3',{staticClass:"pa-4"},[_vm._v(_vm._s(_vm.$t('shared.common.login-wait')))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }